(function () {
  'use strict';

  function initAuraaHero(section) {
    if (!section || section.dataset.auraaHeroReady === 'true') return;
    section.dataset.auraaHeroReady = 'true';

    var addButton = section.querySelector('[data-auraa-hero-add]');
    var revealItems = section.querySelectorAll('[data-auraa-reveal]');

    function reveal() {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal();
            observer.disconnect();
          }
        });
      }, { threshold: 0.08 });
      observer.observe(section);
    } else {
      reveal();
    }

    async function fallbackAddToCart(variantId) {
      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      var addResponse = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });

      var addData = await addResponse.json().catch(function () { return {}; });
      if (!addResponse.ok) {
        throw new Error(addData.description || addData.message || 'Unable to add AURAA COFFEE.');
      }

      var cartResponse = await fetch(root + 'cart.js', {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        cache: 'no-store'
      });
      var cart = await cartResponse.json();

      try {
        document.dispatchEvent(new CustomEvent('auraa:cart:updated', { detail: { cart: cart } }));
      } catch (error) {
        // Custom event is an optional compatibility helper.
      }

      if (window.AuraaCart && typeof window.AuraaCart.open === 'function') {
        await window.AuraaCart.open();
      } else if (typeof window.openAuraaCartDrawer === 'function') {
        await window.openAuraaCartDrawer();
      } else {
        window.location.href = root + 'cart';
      }
    }

    if (addButton) {
      addButton.addEventListener('click', async function () {
        if (addButton.disabled || addButton.classList.contains('is-loading')) return;

        var variantId = Number(addButton.dataset.variantId || 0);
        if (!variantId) return;

        var label = addButton.querySelector('[data-auraa-hero-button-label]');
        var originalLabel = label ? label.textContent : '';

        addButton.classList.add('is-loading');
        addButton.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'ADDING...';

        try {
          if (window.AuraaCart && typeof window.AuraaCart.add === 'function') {
            await window.AuraaCart.add(variantId, 1);
          } else {
            await fallbackAddToCart(variantId);
          }

          if (label) label.textContent = 'ADDED';
          window.setTimeout(function () {
            if (label) label.textContent = originalLabel;
          }, 1200);
        } catch (error) {
          console.error('AURAA hero add-to-cart error:', error);
          if (label) label.textContent = 'TRY AGAIN';
          window.setTimeout(function () {
            if (label) label.textContent = originalLabel;
          }, 1800);
        } finally {
          addButton.classList.remove('is-loading');
          addButton.removeAttribute('aria-busy');
        }
      });
    }
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-auraa-hero]').forEach(initAuraaHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();